var MemberSettingAuthMode = /* @__PURE__ */ ((MemberSettingAuthMode2) => {
  MemberSettingAuthMode2["PhonePin"] = "phone-pin";
  MemberSettingAuthMode2["UsernamePassword"] = "username-password";
  return MemberSettingAuthMode2;
})(MemberSettingAuthMode || {});
var MemberSettingFundingMode = /* @__PURE__ */ ((MemberSettingFundingMode2) => {
  MemberSettingFundingMode2["EWalletOnly"] = "e-wallet-only";
  MemberSettingFundingMode2["BankOnly"] = "bank-only";
  return MemberSettingFundingMode2;
})(MemberSettingFundingMode || {});
var MemberSettingNameMode = /* @__PURE__ */ ((MemberSettingNameMode2) => {
  MemberSettingNameMode2["FullInFirst"] = "full-in-first";
  MemberSettingNameMode2["FirstLast"] = "first-last";
  MemberSettingNameMode2["FirstMiddleLast"] = "first-middle-last";
  return MemberSettingNameMode2;
})(MemberSettingNameMode || {});
var MemberSettingDepositMethodGrouping = /* @__PURE__ */ ((MemberSettingDepositMethodGrouping2) => {
  MemberSettingDepositMethodGrouping2["Individual"] = "individual";
  MemberSettingDepositMethodGrouping2["Group"] = "group";
  return MemberSettingDepositMethodGrouping2;
})(MemberSettingDepositMethodGrouping || {});
export {
  MemberSettingAuthMode,
  MemberSettingDepositMethodGrouping,
  MemberSettingFundingMode,
  MemberSettingNameMode
};
